module.exports = __webpack_public_path__ + "static/media/PDX-2018-Tech-Crawl.2dcfb381.png";